<app-nav-bar>
  <ul mobile class="nav-bar__mobile__items">
    <li class="nav-bar__mobile__item" data-testid="header-privacy-policy">
      <a target="_blank" href="https://www.rocketclose.com/privacy-policy" rel="noopener">Privacy Policy</a>
    </li>
    <li class="nav-bar__mobile__item" data-testid="header-terms-of-use">
      <a target="_blank" href="https://www.rocketclose.com/terms-of-use" rel="noopener">Terms of Use</a>
    </li>
    <li class="nav-bar__mobile__item">
      <a mat-button
         class="phone-button"
         href="tel:{{ this.clearSignSupportNumber }}"
         tabIndex="0"
         data-testid="header-support-phoneNumber"
         rel="noopener"
         title="Support Phone Number">
        <span>
          {{ this.clearSignSupportNumber }}
          <img src="assets/icons/phone_in_talk-icon.svg" alt="Phone Icon">
        </span>
      </a>

    </li>
  </ul>

  <a mat-button
     class="phone-button"
     href="tel:{{ this.clearSignSupportNumber }}"
     tabIndex="0"
     data-testid="header-support-phoneNumber"
     rel="noopener"
     title="Support Phone Number">
    <span>
      {{ this.clearSignSupportNumber }}
      <img src="assets/icons/phone_in_talk-icon.svg" alt="Phone Icon">
    </span>
  </a>


  <app-menu [isPrivacyPolicyButtonEnabled]="true"
            [isTermsOfUseButtonEnabled]="true"></app-menu>
</app-nav-bar>
